<template>
	<div class="results-overview-footer">
		<div class="container border-top">
			<div class="footer-abstarct-wrapper p-0">
				<div class="footer-call-to-action pt-5 pb-5 border-bottom">
					<header class="result-table-item-location-header">{{ApplyHeader}}</header>
						<p>
							{{ TextApply }}
						</p>
						<a
							:href="getHRLink"
							class="ps-4 pe-4 btn btn-tertiary btn-apply mt-3"
							target="_blank"
						>
							{{ ButtonApply }}
					</a>
				</div>
				<!--Row Starts-->
				<div class="sm-flex-column">
					<!--Text Contact details -->
					<template v-for="(el) in datajobs">
						<span v-if="el.stellenangebotId == stellenangebotId" :key="el.stellenangebotId">
							<div class="result-table-cell flex-basis-100 pt-5 pb-5">
							<div class="center-wrapper"
								v-for="(el, jobOrte) in el.jobOrte"
								:key="jobOrte"
							>
								<template v-for="itemSubsidiary in subsidiary">
									<span v-if="itemSubsidiary.plz == el.jobPlz" :key="itemSubsidiary.plz">
										<header class="result-table-item-location-header">
											{{ Header }}
										</header>
										<p class="mb-3 shortread">
											Immobilien Service Deutschland {{ itemSubsidiary.ort }}
										</p>
										<dl class="mb-0 row gx-0 adress-location-list">
											<dd>{{ itemSubsidiary.strasse }}</dd>
											<dd>{{ itemSubsidiary.plz }} {{ itemSubsidiary.ort }}</dd>
											<dt class="col-md-2 subsidiary-item-sm">
												<font-awesome-icon
													class="me-2 phone-icon-isd"
													:icon="['isd', 'jetzt-anrufen']"
												/>Telefon:</dt>
											<dd class="col-md-9">
												<a
													:href="`tel:${itemSubsidiary.telefon}`"
													title="Telefon"
												>
													{{ itemSubsidiary.telefon }}
												</a>
											</dd>
											<!-- <dt class="col-md-2 subsidiary-item-sm">
												<font-awesome-icon
													class="me-2"
													:icon="['fal', 'fax']"
												/>Fax:</dt>
											<dd class="col-md-9">{{ itemSubsidiary.fax }}</dd> -->
											<dt class="col-md-2 subsidiary-item-sm">
												<font-awesome-icon
													class="me-2 mail-icon-isd"
													:icon="['isd', 'mail']"
												/>E-Mail:</dt>
											<dd class="col-md-9">
												<a
													:href="`mailto:${itemSubsidiary.email}`"
													title="E-Mail"
												>
													{{ itemSubsidiary.email }}
												</a>
											</dd>
										</dl>
									</span>
								</template>
							</div>
							</div>
						</span>
					</template>
				</div>
				<!--Row Ends-->
			</div>
		</div>
		<div class="container">
			<div class="pt-4 col col-md-4 mt-4">
				<nuxt-link exact to="/bewerber/jobsuche/jobboerse" class="ps-4 pe-4 btn btn-tertiary">
					{{ ButtonBack }}
				</nuxt-link>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {

	data() {
		return {
			stellenangebotId: this.$route.params.stellenangebotId,
			Header: 'Unsere Niederlassung',
			ButtonBack: 'Zurück zur Listenansicht',
			ButtonApply: 'Auf diese Stelle bewerben',
			ApplyHeader: 'Jetzt bewerben!',
			TextApply: 'Finde heraus, wie einfach die Suche nach deinem neuen Job sein kann und gestalte dein Berufsleben mit uns! Bei Immobilien Service Deutschland findest du den Job, den du gerade brauchst.',
		};
	},
	computed: {
		...mapState([
			'subsidiary',
			'datajobs'
		]),
		itemSubsidiary() {
			return this.$store.state.subsidiary.find(item => item.plz);
		},
		getHRLink() {
			const pattern = /(?<!hr\d*)\d+/g;

			const jobId = this.stellenangebotId.match(pattern);
			return `https://personaintern.hr4you.org/job/apply/${jobId}`
		}
	},
	mounted() {
		this.$store.dispatch("createDataJobs");
	},
}
</script>

<style lang="scss">
@import '~@/assets/scss/common';
.results-overview-footer {
	.result-table-item-location-header {
		@include responsive-type(3, 1.5);
		color: $primary;
	}

	.adress-location-list {
		@include media-breakpoint-up(lg) {
			width: 60%;
		}
	}

	@include media-breakpoint-down(md) {
		.btn {
			width: 100%;
		}
	}

	.mail-icon-isd {
		font-size: 1rem;
	}
	.phone-icon-isd {
		font-size: 1.5rem;
	}

}
</style>
